export default {
  baseinfo: {
    dataSource: '数据源',
    language: '语言语种',
    languageNote: '请选择语言语种',
    english: '英文',
    chinese: '中文',
    others: '其他',
    othersLang: '填写其他语言，如法语',
    standard: '普通话',
    yes: '是',
    no: '否',
    othersStandard: '填写非普通话，如东北话',
    content: '内容类型',
    history: '历史',
    education: '教育',
    technology: '科技',
    otherContent: '请填写其他内容类型',
    scene: '场景类别',
    sceneType1: '标准无杂声',
    sceneType2: '电话',
    sceneType3: '对讲机',
    oherScene: '请填写其他场景类别',
    frequency: '音频采样率',
    frequencyNote: '请选择音频的采样率',
    depth: '采样深度',
    depthNote: '请选择音频的采样深度',
    wavRadio: '音频通道',
    wavRadio1: '单',
    wavRadio2: '双',
    format: '文件格式',
    formatOther: '请填写其他文件格式',
    remarks: '备注',
    skillTitle: '采集员或标注员所需技能',
    skill: '所需技能',
    qualifiedTitle: '数据合格标准',
    qualified: '合格标准',
    criterionTitle: '有效性判断准则',
    criterion: '判断准则',
    js: {
      rules: {
        language: '请选择语言语种',
        languageOther: '请填写其他语言语种',
        standard: '请选择是否为普通话',
        contentTypeOther: '请填写其他内容类型',
        format: '请至少选择一个文件格式',
        formatOther: '请填写文件格式',
        qualified: '请填写合格标准',
        skill: '请填写所需技能',
        criterion: '请填写有效性判断准则'
      }
    }
  },
  business: {
    template: '模板设定',
    labelDesign: '标签设计',
    radio: '单选题',
    checkbox: '多选题',
    show1: '语音标注模板（快速预览）',
    show2: '语音转写模板（快速预览）',
    show3: '语音切割模板（快速预览）',
    labelTag: '标注标签',
    cut: '是否切割',
    cut1: '是',
    cut2: '否',
    invalid: '无效音说明',
    special: '特殊转写说明',
    introduce: '任务介绍',
    brief: '任务简介',
    taskDate: '任务时间',
    date: '起止时间',
    startDate: '开始日期',
    to: '至',
    endDate: '结束日期',
    js: {
      rules: {
        brief1: '请填写任务简介',
        brief2: '长度128个字符以内',
        introduce1: '请填写任务介绍',
        introduce2: '长度1024个字符以内',
        date1: '请选择起止时间'
      },
      title: '题目',
      label: '选项',
      labelContent: '选项含义',
      text: '填空题'
    }
  },
  qcprice: {
    scale: '数据规模',
    voiceNum: '音频数量',
    num: '条',
    hour: '小时(总时间)',
    voiceQuality: '音频质量',
    voiceQuaNote: '请选择音频质量',
    taskTime: '任务预估时间',
    minute: '分钟（每条音频标注预估耗时）',
    checkType: '质检方式',
    checkType2: '质检方式',
    checkTypeNote: '请选择质检方式',
    checkProportion1: '审核价格比例',
    checkProportion2: '%（审核任务的报酬占做任务的的报酬比例）',
    spotCheck1: '抽检比例',
    spotCheck2: '%',
    spotCheck3: '抽查数量【',
    spotCheck4: '小时】审核任务单价【',
    spotCheck5: '泛函币/小时】',
    allCheckNum1: '检查次数',
    allCheckNum2: '次',
    allCheckNum3: '检查数量【',
    allCheckNum4: '小时】审核任务单价【',
    allCheckNum5: '泛函币/小时】',
    rightAnswer1: '累计答案',
    rightAnswer2: '个/条',
    tagNumber1: '标注人数',
    tagNumber2: '人/条（每条数据最多多少人做）',
    tagNumber3: '至少标注【',
    tagNumber4: '小时】',
    tagNumber5: '最多标注【',
    goldTest1: '比例',
    goldTest2: '预计标注【',
    price1: '报价',
    quotenote: '如果您愿意给到标注员100泛函币作为劳动报酬，泛函将额外收取30泛函币作为平台服务费，您总共需要支付130泛函币。',
    price2: '建议价格【',
    price3: '最低价格【',
    offer1: '您愿意给到标注员的劳动报酬',
    offer2: '泛函币/小时',
    sum1: '审核任务总价【',
    sum2: '泛函币】',
    sum3: '总价【',
    js: {
      rules: {
        num1: '条数不能为空',
        num2: '条数必须为数字值',
        hour1: '总时长不能为空',
        hour2: '总时长必须为数字值',
        scale1: '数据大小不能为空',
        scale2: '数据大小必须为数字值',
        voiceQuality: '请选择音频质量',
        taskTime1: '任务预估时间不能为空',
        taskTime2: '任务预估时间必须为数字值',
        checkType: '请选择质检方式',
        checkProportion1: '不能为空',
        checkProportion2: '必须为数字值',
        spotCheck1: '抽检比例不能为空',
        spotCheck2: '抽检比例必须为数字值',
        allCheckNum1: '全检次数不能为空',
        allCheckNum2: '全检次数必须为数字值',
        rightAnswer1: '不能为空',
        rightAnswer2: '必须为数字值',
        tagNumber1: '标注人数不能为空',
        tagNumber2: '标注人数必须为数字值',
        goldTest1: '不能为空',
        goldTest2: '必须为数字值',
        offer1: '客户单价不能为空',
        offer2: '客户单价必须为数字值'
      }
    }
  },
  sample: {
    name: '名称',
    describe: '描述',
    selectExample: '样例数据',
    selectExampleNote: '请选择样例数据',
    fileName: '文件名',
    fileSize: '大小',
    scope: '操作',
    choiceVoice: '上传新文件',
    uploadVoice: '点击上传文件',
    uploadVoiceNote: '只能上传音频文件，且不超过20Mb',
    trueExample: '正确样例列表',
    falseExample: '错误样例列表',
    addExample: '添加样例',
    true: '确定',
    cancel: '取消',
    delete: '删除',
    exampledata: '样例数据',
    selectexamdata: '请选择样例数据',
    uploadnewfile: '上传新文件',
    confirm: '确定',
    reset: '取消',
    filename: '文件名',
    filesize: '大小',
    operate: '操作',
    remove: '移除',
    lessupload: ' 只能上传音频文件，且不超过20Mb',
    clickupload: '点击上传文件',
    save: '保存',
    trueexample: '正确样例列表',
    addexample: '添加样例',
    errorexample: '错误样例列表',
    js: {
      rules: {
        name1: '请输入名称',
        name2: '长度在 1 到 10 个字符',
        selectExample: '请选择样例数据'
      },
      addStatus: {
        type1: '修改答案',
        type2: '添加答案'
      },
      success: {
        type1: '成功',
        type2: '确定',
        type3: '删除成功',
        type4: '上传成功',
        type5: '添加成功'
      },
      error: {
        type1: '失败',
        type2: '警告',
        type3: '取消',
        type4: '图片上传出错，请刷新重试！',
        type5: '每个用户最多上传10个文件',
        type6: '文件太大'
      },
      deleteSampleFile: '移除文件后，对应的样例也会被删除,是否继续',
      deleteSampleItem: '样例正被删除,是否继续?'
    }
  },
  tutorial: {
    tutorial: '教程',
    finish: '完成'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/pushWav.js